import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  handleFormItemSubmit,
  returnToCart
} from 'bento-ordering/menus/actions/menuItem';
import MenuItemDetailForm from 'bento-ordering/menus/containers/MenuItemDetailForm';
import ModalCloseButton from 'bento-ordering/base/ui_components/ModalCloseButton';
import { MENU_ITEM } from 'constants/menu/formTypes';
import { ADD_TO_CART } from 'constants/menu/ctaName';
import { styled } from '@mui/system';
import { UPSELL } from 'bento-ordering/cart/constants/conversionMethods';
import {
  getMenuItemImage,
  getMenuItem
} from 'bento-ordering/menus/reducers/menuItemsDetail';
import HeaderAndNavigationTypography from 'components/HeaderAndNavigationTypography';
import useGetModifierGroups from 'hooks/useGetModifierGroups';
import { useWouldExceedSpendingLimit } from 'bento-ordering/group_ordering/hooks/index';

const StyledSkipToCheckoutWrapper = styled('div')({
  marginTop: '16px',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer'
});

const StyledSkipToCheckout = styled(HeaderAndNavigationTypography)({
  fontSize: '14px',
  textTransform: 'uppercase'
});

const SkipToCheckoutButton = () => {
  const dispatch = useDispatch();

  return (
    <StyledSkipToCheckoutWrapper onClick={() => dispatch(returnToCart())}>
      <StyledSkipToCheckout>SKIP TO CHECKOUT</StyledSkipToCheckout>
    </StyledSkipToCheckoutWrapper>
  );
};

const MenuUpsellItemDescription = ({
  match: {
    params: { menuItemSlug }
  }
}) => {
  const dispatch = useDispatch();
  const menuItem = useSelector(state => getMenuItem(state, menuItemSlug));
  const pricePreview = useSelector(state =>
    state.productPreview.final_price.toFixed(2)
  );
  const modifierGroups = useGetModifierGroups(menuItem);

  const menuItemImage = getMenuItemImage(menuItem);
  const { name, id, slug } = menuItem;
  const {
    hasExceededSpendingLimit,
    spendingLimit
  } = useWouldExceedSpendingLimit();

  return (
    <React.Fragment>
      <ModalCloseButton
        autoFocus
        handleClick={() => dispatch(returnToCart())}
        isWhite={!!menuItemImage}
      />
      <MenuItemDetailForm
        pricePreview={pricePreview}
        defaultCtaName={ADD_TO_CART}
        handleFormItemSubmit={handleFormItemSubmit}
        productId={id}
        productName={name}
        conversion_method={UPSELL}
        productSlug={slug}
        formType={MENU_ITEM}
        menuItemImage={menuItemImage}
        menuItemDescriptionProps={{
          ...menuItem,
          default_price: null
        }}
        SkipToCheckoutButton={<SkipToCheckoutButton />}
        modifierGroups={modifierGroups}
        variants={menuItem.variants}
        spendingLimit={spendingLimit}
        hasExceededSpendingLimit={hasExceededSpendingLimit}
      />
    </React.Fragment>
  );
};

MenuUpsellItemDescription.propTypes = {
  match: PropTypes.object.isRequired
};

export default MenuUpsellItemDescription;
